import { classes, mesaColorNames } from '@/src/common/theme'
import type { ComponentProps } from 'react'
import Animated from 'react-native-reanimated'

type CardProps = ComponentProps<typeof Animated.View>

interface Props extends CardProps {
  children: NonNullable<CardProps['children']>
  /** @deprecated */
  additionalStyles?: CardProps['style']
}

export const cardBorderRadius = 16

export function Card({
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  additionalStyles,
  ...props
}: Props & Pick<ComponentProps<typeof Animated.View>, 'style'>) {
  return (
    <Animated.View
      {...props}
      style={[
        {
          backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
          paddingTop: 10,
          paddingBottom: 10,
          paddingLeft: 10,
          paddingRight: 10,
          borderRadius: cardBorderRadius,
        },
        classes.cardShadow,
        additionalStyles,
        props.style,
      ]}
    />
  )
}
